import {StyledEngineProvider} from '@mui/material/styles';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';

const root = ReactDOM.createRoot(
   document.getElementById('tradeinroot') as HTMLElement
);

root.render(
   <StyledEngineProvider injectFirst>
      <App/>
   </StyledEngineProvider>
);
